// src/components/TextInput/TextInput.tsx
import React from 'react';
import Typography from './Typography';
import Colors from '../Colors/Colors';
import './TextInput.css';

interface TextInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  className?: string;
  style?: React.CSSProperties;
  type?: string; // default is 'text'
  label?: string;
  error?: string;
}

const TextInput: React.FC<TextInputProps> = ({
  value,
  onChange,
  placeholder = '',
  className = '',
  style,
  type = 'text',
  label,
  error,
}) => {
  return (
    <div className={`text-input-container ${className}`}>
      {label && (
        <Colors variant="black">
          <Typography variant="body-small-bold" className="text-input-label">
            {label}
          </Typography>
        </Colors>
      )}
      
      <div className="text-input-wrapper">
        <input
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`text-input ${error ? 'text-input-error' : ''}`}
          style={style}
        />
        
        {value && (
          <Colors variant="black">
            <Typography
              variant="body"
              className="text-input-measure"
            >
              {value}
            </Typography>
          </Colors>
        )}
      </div>
      
      {error && (
        <Colors variant="warning-red">
          <Typography variant="body-small" className="text-input-error-message">
            {error}
          </Typography>
        </Colors>
      )}
    </div>
  );
};

export default TextInput;